import { Component, EventEmitter, inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { MaintenanceRoutineSupplyModel } from 'src/app/models/maintenance/maintenance-routine-supply.model';
import { MaintenanceRoutineModel } from 'src/app/models/maintenance/maintenance-routine.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaintenanceRoutineSupplyService } from 'src/app/services/maintenance/maintenance-routine-supply.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-maintenance-routine-supply',
  templateUrl: './register-maintenance-routine-supply.component.html',
  styleUrls: ['./register-maintenance-routine-supply.component.scss'],
  standalone: false
})
export class RegisterMaintenanceRoutineSupplyComponent implements OnInit {
  public config = inject(DynamicDialogConfig);
  private readonly articleService = inject(ArticleService);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly maintenanceRoutineSupplyService = inject(MaintenanceRoutineSupplyService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  @Optional() private ref = inject(DynamicDialogRef);

  @ViewChild('articleSelection') articleSelectionModalComponent?: CustomModalComponent | null = null;
  @Input() disabled: boolean = false;
  @Input('maintenanceRoutineContract')
  set changeMaintenance(change: MaintenanceRoutineModel) {
    this.changeMaintenanceRoutine(change);
  }
  @Input('maintenanceRoutineSupplyContract')
  set changeMaintenanceSupply(change: MaintenanceRoutineSupplyModel) {
    this.changeMaintenanceRoutineSupply(change);
  }
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  articleId: number = 0;
  codeNameArticle: string = "";
  componentTableSelection = CustomTableSelectComponent;
  ascendantArticle: boolean = true;
  columnSortArticle: string | null = null;
  dataArticle: PagedResponseModel<any> = new PagedResponseModel<any>();
  formMaintenanceRoutineSupply: FormGroup;
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
    actions: []
  });

  limitArticle: number = 5;
  listArticles: any[] = [];
  maintenanceRoutineSupplyId: number = 0;
  maintenanceRoutineContract: MaintenanceRoutineModel = new MaintenanceRoutineModel();
  maintenanceRoutineSupplyContract: MaintenanceRoutineSupplyModel = new MaintenanceRoutineSupplyModel();
  output$ = new Subject<any>();
  pageArticle: number = 1;
  subscription: Subscription;

  ngOnInit() {
    this.validateForm(new MaintenanceRoutineSupplyModel());
    this.getListSuppliesForSelect();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }


  changeMaintenanceRoutine(maintenanceRoutine: MaintenanceRoutineModel) {
    if (maintenanceRoutine.maintenanceRoutineId != 0) {
      this.maintenanceRoutineContract = maintenanceRoutine;
    }
  }

  changeMaintenanceRoutineSupply(maintenanceRoutineSupply: MaintenanceRoutineSupplyModel) {
    this.maintenanceRoutineSupplyContract = maintenanceRoutineSupply;
    this.maintenanceRoutineSupplyId = maintenanceRoutineSupply.maintenanceRoutineSupplyId;

    this.validateForm(maintenanceRoutineSupply);

    if (maintenanceRoutineSupply.maintenanceRoutineSupplyId !== 0) {
      // this.subrentalEntryDetailId = changeSubrentalDetail.inventoryEntryDetailId;
      // await Promise.all([
      //   this.getStore(changeSubrentalDetail.storeId, false),
      //   this.getArticle(changeSubrentalDetail.articleId, false)
      // ]);
      // await this.getStocksByArticleIdStoreId();
    }
  }


  clearForm() {
    this.articleId = 0;
    this.codeNameArticle = "";
    const modelMaintenanceRoutineSupply = new MaintenanceRoutineSupplyModel();
    this.validateForm(modelMaintenanceRoutineSupply)
    this.isFormView.emit(false);
  }

  async getArticle(articleId: number | null, reload: boolean) {
    let validArticle = null;
    let codeNameArticle = "";
    if (articleId != null) {
      const article = await firstValueFrom(this.articleService.getArticleById(articleId));
      if (article) {
        validArticle = articleId;
        codeNameArticle = `${article.code} - ${article.name}`;
      }
    }

    this.articleId = validArticle ?? 0;
    this.codeNameArticle = codeNameArticle;
    this.formMaintenanceRoutineSupply.controls["articleId"].patchValue(validArticle);
    if (reload) {
      await this.getMaintenanceRoutineSupplyByKeys();
    }
  }

  async getAllSupplies() {
    try {
      this.dataArticle = await firstValueFrom(this.maintenanceRoutineSupplyService.getAllSupplies(this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos', error);
    }
  }

  async getColumnsArticle() {
    try {
      this.headerArticle = await firstValueFrom(this.maintenanceRoutineSupplyService.getColumnsForArticlesAsync());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getListSuppliesForSelect() {
    try {
      this.listArticles = await firstValueFrom(this.maintenanceRoutineSupplyService.getAllSuppliesForSelect());
    } catch (error) {
      console.error('Error al obtener la lista de artículos.', error);
    }
  }

  async getMaintenanceRoutineSupplyByKeys() {
    try {
      const maintenanceRoutineSupply = await firstValueFrom(this.maintenanceRoutineSupplyService.getMaintenanceRoutineSupplyByKeysAsync(this.maintenanceRoutineContract.maintenanceRoutineId, this.articleId));
      this.maintenanceRoutineSupplyContract = maintenanceRoutineSupply;
      this.maintenanceRoutineSupplyId = maintenanceRoutineSupply.maintenanceRoutineSupplyId;
      this.validateForm(maintenanceRoutineSupply);
    } catch (error) {
      console.error('Error al obtener el insumo.', error);
    }
  }


  async handleSelectedItem(selectedItem: any) {
    const articleId = parseInt(selectedItem[0]?.id);
    this.articleId = articleId;
    this.formMaintenanceRoutineSupply.controls["articleId"].patchValue(articleId);
    await this.getMaintenanceRoutineSupplyByKeys();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllSupplies();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getAllSupplies()]
    );
    this.updateInputs();
    this.articleSelectionModalComponent && this.articleSelectionModalComponent.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send(): Promise<any> {
    if (this.formMaintenanceRoutineSupply.valid) {

      const modelMaintenanceRoutineSupply = this.formMaintenanceRoutineSupply.getRawValue() as MaintenanceRoutineSupplyModel;
      modelMaintenanceRoutineSupply.maintenanceRoutineId = this.maintenanceRoutineContract.maintenanceRoutineId;

      if (this.validateQuantities(modelMaintenanceRoutineSupply)) {
        this.toastHandlerService.showToast('warning', 'Debe ingresar al menos una cantidad.', 'Atención');
        return;
      }

      try {
        if (this.maintenanceRoutineSupplyId == 0) {
          await firstValueFrom(this.maintenanceRoutineSupplyService.createAsync(modelMaintenanceRoutineSupply));
          this.toastHandlerService.showToast('success', 'El insumo fue creado exitosamente.', '');
        }
        else {
          this.maintenanceRoutineSupplyContract.quantityEachUse = modelMaintenanceRoutineSupply.quantityEachUse;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity1 = modelMaintenanceRoutineSupply.maintenancePlanQuantity1;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity2 = modelMaintenanceRoutineSupply.maintenancePlanQuantity2;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity3 = modelMaintenanceRoutineSupply.maintenancePlanQuantity3;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity4 = modelMaintenanceRoutineSupply.maintenancePlanQuantity4;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity5 = modelMaintenanceRoutineSupply.maintenancePlanQuantity5;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity6 = modelMaintenanceRoutineSupply.maintenancePlanQuantity6;
          this.maintenanceRoutineSupplyContract.maintenancePlanQuantity7 = modelMaintenanceRoutineSupply.maintenancePlanQuantity7;
          await firstValueFrom(this.maintenanceRoutineSupplyService.updateAsync(this.maintenanceRoutineSupplyContract));
          this.toastHandlerService.showToast('success', 'El insumo fue modficado exitosamente.', '');
        }

        this.maintenanceRoutineSupplyContract = new MaintenanceRoutineSupplyModel();
        this.clearForm();
        this.isFormView.emit(true);
        this.updateListDetail.emit(true);
      } catch (error) {
        console.error('Error al guardar el insumo.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      articleId: {
        required: 'El campo artículo es obligatorio.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formMaintenanceRoutineSupply.get(controlName);

      if (control && control.invalid && control.errors) {
        const errors = control.errors;

        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  validateForm(maintenanceRoutineSupply: MaintenanceRoutineSupplyModel) {
    this.formMaintenanceRoutineSupply = this.formBuilder.group({
      articleId: [maintenanceRoutineSupply.articleId, [Validators.required, Validators.min(1)]],
      quantityEachUse: [maintenanceRoutineSupply.quantityEachUse, []],
      maintenancePlanQuantity1: [maintenanceRoutineSupply.maintenancePlanQuantity1, []],
      maintenancePlanQuantity2: [maintenanceRoutineSupply.maintenancePlanQuantity2, []],
      maintenancePlanQuantity3: [maintenanceRoutineSupply.maintenancePlanQuantity3, []],
      maintenancePlanQuantity4: [maintenanceRoutineSupply.maintenancePlanQuantity4, []],
      maintenancePlanQuantity5: [maintenanceRoutineSupply.maintenancePlanQuantity5, []],
      maintenancePlanQuantity6: [maintenanceRoutineSupply.maintenancePlanQuantity6, []],
      maintenancePlanQuantity7: [maintenanceRoutineSupply.maintenancePlanQuantity7, []],
    });
  }

  validateQuantities(modelMaintenanceRoutineSupply: MaintenanceRoutineSupplyModel): boolean {
    const quantitySum = modelMaintenanceRoutineSupply.quantityEachUse + modelMaintenanceRoutineSupply.maintenancePlanQuantity1 + modelMaintenanceRoutineSupply.maintenancePlanQuantity2 + modelMaintenanceRoutineSupply.maintenancePlanQuantity3 + modelMaintenanceRoutineSupply.maintenancePlanQuantity4 + modelMaintenanceRoutineSupply.maintenancePlanQuantity5 + modelMaintenanceRoutineSupply.maintenancePlanQuantity6 + modelMaintenanceRoutineSupply.maintenancePlanQuantity7;
    return quantitySum === 0;
  }
}
